import { useLayoutEffect, useState } from 'react';

const SIN = Math.sin(Math.PI / 3);
const COS = Math.cos(Math.PI / 3);
const BREATHING_ROOM = 8;

// Rotated labels don't take up layout space, so the header can't size itself to them.
const useAngledHeaderHeight = (headerRef: React.RefObject<HTMLElement>, labelKey: string) => {
  const [height, setHeight] = useState<number>();

  useLayoutEffect(() => {
    let cancelled = false;
    const measure = () => {
      if (cancelled) return;
      const labels = headerRef.current?.querySelectorAll<HTMLElement>('[data-angled-label]') ?? [];
      const tallest = Math.max(0, ...[...labels].map(label => (
        label.offsetWidth * SIN + label.offsetHeight * COS
      )));
      setHeight(Math.ceil(tallest + BREATHING_ROOM));
    };

    measure();
    document.fonts?.ready.then(measure);

    return () => { cancelled = true; };
  }, [headerRef, labelKey]);

  return height;
};

export default useAngledHeaderHeight;
